export default "__VITE_ASSET__B$1Lxoha__"